<template lang="pug">
.flex.items-center.justify-start.w-full.min-w-64.gap-x-1(class="md:gap-x-2")
  //- div
  Input.w-full.border-0.h-8.new-user-id(v-model='newUserId' placeholder='跳去哪个ID/邮箱？' @keyup.enter.native="jump(false)" class="bg-[var(--background-color-pure)] md:max-w-64 text-base")
  //- div
  Button.min-w-16(variant="secondary" @click="jump(false)" size="sm" class="md:min-w-22") 跳转
</template>

<script lang="ts" setup>
import { Button } from '@/components/ui/button'
import { toast } from '~/utils/sonner'
const newUserId = ref('')
const lastJump = ref()
const normalizeJumpTarget = (value: string) => value
  .replace(/\s+/g, '')
  .replace(/^\uFEFF/, '')
  .replace(/^\u00EF?\u00BB\u00BF/, '')
  .replace(/^mailto:/i, '')
const jump = async (keepPath) => {
  const lastUserId = useRoute().params.userId
  console.log('>>>>>>>>>>>>>>>>>>>> jumping... keepPath:', keepPath)

  newUserId.value = normalizeJumpTarget(newUserId.value)
  if (newUserId.value) {
    if (newUserId.value === lastJump.value) {
      return
    }
    if (isNaN(Number(newUserId.value))) {
      if (newUserId.value?.includes?.(',')) {
        newUserId.value = newUserId.value.replace(/,/g, '')
      } else if (newUserId.value?.indexOf('@') === -1) {
        return toast({
          title: '请输入正确的用户ID或邮箱',
        })
      }
    }
    lastJump.value = newUserId.value
    console.log(useRoute().params)
    if (useRoute().params.userId && keepPath) {
      await navigateTo({
        params: {
          userId: newUserId.value
        }
      })
    } else {
      console.log('pushing route...')
      await navigateTo(`/dashboard/${newUserId.value}`)
    }
    const currentUserId = useRoute().params.userId
    if (currentUserId !== lastUserId) {
      toast({
        title: '已跳转到用户' + newUserId.value,
      })
    }
  }
}
watch(newUserId, (newVal) => {
  const normalizedNewUserId = normalizeJumpTarget(newVal)
  if (normalizedNewUserId !== newVal) {
    newUserId.value = normalizedNewUserId
  }
})
</script>

<style lang="postcss">
.new-user-id {
  input {
    font-size: 1.1rem;
  }
}
</style>
